import { render, staticRenderFns } from "./PlayerStatsTables.vue?vue&type=template&id=36dbb5c0&scoped=true&"
import script from "./PlayerStatsTables.vue?vue&type=script&lang=js&"
export * from "./PlayerStatsTables.vue?vue&type=script&lang=js&"
import style0 from "./PlayerStatsTables.vue?vue&type=style&index=0&id=36dbb5c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36dbb5c0",
  null
  
)

export default component.exports